@let status = orderStatus();
@let statusKey = statusRelation();
@let testId = id();
@let statusText =
  texts() | filterTexts: statusKey : EEntityType.directTicket | language;

@if (type() === EStatusChipType.icon) {
  <div
    class="flex flex-row items-center px-1 text-sm"
    [attr.data-testid]="'order-status-' + testId"
    [ngStyle]="{
      borderRadius: corporateDesign.borderRadius(),
    }"
    [ngClass]="{
      'bg-green-100 text-green-700': status === EOrderStatus.complete,
      'bg-yellow-100 text-yellow-700':
        status === EOrderStatus.inProgress ||
        status === EOrderStatus.pendingPaymentVerification,
      'bg-red-100 text-red-800':
        status === EOrderStatus.cancelled || status === EOrderStatus.rejected,
    }">
    @if (status === EOrderStatus.complete) {
      <span
        class="material-symbols-rounded pr-1 text-lg!"
        [attr.data-testid]="'order-status-icon-complete-' + testId"
        >check_circle</span
      >
    }
    @if (
      status === EOrderStatus.inProgress ||
      status === EOrderStatus.pendingPaymentVerification
    ) {
      <span
        class="material-symbols-rounded pr-1 text-lg!"
        [attr.data-testid]="'order-status-icon-in-progress' + testId"
        >arrow_circle_right</span
      >
    }
    @if (
      status === EOrderStatus.cancelled || status === EOrderStatus.rejected
    ) {
      <span
        class="material-symbols-rounded pr-1 text-lg!"
        [attr.data-testid]="'order-status-icon-cancelled' + testId"
        >cancel</span
      >
    }

    {{ statusText }}
  </div>
}
@if (type() === EStatusChipType.label) {
  <div
    class="text-sm"
    [attr.data-testid]="'ticket-status-' + testId"
    [ngClass]="{
      'text-green-700': status === EOrderStatus.complete,
      'text-yellow-700':
        status === EOrderStatus.inProgress ||
        status === EOrderStatus.pendingPaymentVerification,
      'text-red-800':
        status === EOrderStatus.cancelled || status === EOrderStatus.rejected,
    }">
    {{ statusText }}
  </div>
}
@if (type() === EStatusChipType.dark) {
  <div
    class="flex w-fit flex-row items-center rounded-xl px-2 text-sm"
    [attr.data-testid]="'order-status-' + testId"
    [ngStyle]="{
      borderRadius: corporateDesign.borderRadius(),
    }"
    [ngClass]="{
      'bg-green-700 text-white': status === EOrderStatus.complete,
      'bg-yellow-400':
        status === EOrderStatus.inProgress ||
        status === EOrderStatus.pendingPaymentVerification,
      'text-qhite bg-red-800':
        status === EOrderStatus.cancelled || status === EOrderStatus.rejected,
    }">
    {{ statusText }}
  </div>
}
